export default "__VITE_ASSET__UyIwMF8e__"